import axios from "axios";
import Utils from "../utils/utils";
import AppLib from "./AppLib";

const SERVER_URL = `${process.env.REACT_APP_SERVER_URL}`;
const HRM_URL = `${process.env.REACT_APP_HRM_URL}`;
let token = Utils.getToken();

const Tickets = {
  STATUS: {
    1: { name: "Open", text: "text-blue-700", bg: "bg-blue-100" },
    2: { name: "In-progress", text: "text-amber-700", bg: "bg-amber-100" },
    3: { name: "Resolved", text: "text-green-700", bg: "bg-green-100" },
    4: { name: "Resolved", text: "text-green-700", bg: "bg-green-100" },
  },
  PRIORITY: {
    1: { name: "Low", text: "text-green-700", bg: "bg-green-100" },
    2: { name: "Medium", text: "text-amber-700", bg: "bg-amber-100" },
    3: { name: "High", text: "text-red-700", bg: "bg-red-100" },
  },
  CATEGORY: {
    LMS: {
      1: "Curriculum Issues",
      2: "Academic Support",
      3: "Leave Requests",
      4: "LMS Support",
      5: "General Help",
      6: "Counseling Services",
      7: "Technical Issues",
      8: "Feedback & Suggestions",
    },
    HRM: {
      1: "LMS",
      2: "HRMS",
      3: "HRMS Support",
      4: "Technical Issues",
      5: "Feedback & Suggestions",
    },
  },
  createTicket: async function (formData) {
    try {
      const response = await axios.post(`${HRM_URL}/tickets`, formData, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error:
          error.response?.data?.message || error.message || "An error occurred",
      };
    }
  },
  getTickets: async function () {
    if (!token) token = AppLib.token; // Get t
    try {
      const response = await axios.get(`${HRM_URL}/tickets`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      return {
        success: true,
        data: response.data.tickets,
      };
    } catch (error) {
      return {
        success: false,
        error:
          error.response?.data?.message ||
          error.message ||
          "An error occurred while fetching tickets",
      };
    }
  },
  getTicket: async function (id) {
    try {
      const response = await axios.get(`${HRM_URL}/tickets/${id}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      return {
        success: true,
        data: response.data.ticket,
      };
    } catch (error) {
      return {
        success: false,
        error:
          error.response?.data?.message ||
          error.message ||
          "An error occurred while fetching ticket",
      };
    }
  },
  assignTicket: async function (ticketId, assignTo, obj) {
    try {
      const payload = { assignTo, summary: obj };
      const url = `${HRM_URL}/tickets/${ticketId}/assign`;
      const response = await axios.put(url, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200) {
        return {
          success: true,
          result: response.data.message || "Assigned successfully!",
          data: response.data.data,
        };
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to update user.";
      console.error("Error in assigning ticket :", error);
      return {
        success: false,
        result: errorMessage,
      };
    }
  },
  markTicketResolve: async function (ticketId, status, summary) {
    try {
      const url = `${HRM_URL}/tickets/resolved/${ticketId}`;
      const response = await axios.put(
        url,
        { status, summary },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        return {
          success: true,
          result: response.data.message,
          data: response.data.data,
        };
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to update user.";
      console.error("Error in marking resolve : ", error);
      return {
        success: false,
        result: errorMessage,
      };
    }
  },
  buzzcussion: async function (ticketId, obj) {
    try {
      const url = `${HRM_URL}/tickets/buzz/${ticketId}`;
      const response = await axios.put(
        url,
        { obj: obj },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        return {
          success: true,
          result: response.data.message || "Message sent !",
          data: response.data.data,
        };
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to sent message";
      return {
        success: false,
        error: errorMessage,
      };
    }
  },
};

export default Tickets;
